import { Component, Host, h } from '@stencil/core';

@Component({
  tag: 'page-sample',
  styleUrl: 'page-sample.css',
  shadow: true,
})
export class PageSample {
  render() {
    return (
      <Host>
        <slot></slot>
      </Host>
    );
  }
}
